module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ca":{"espectacle":"Espectacle"},"es":{"espectacle":"Espectaculo"},"en":{"espectacle":"Spectacle"}}')
  delete Component.options._Ctor
}
